/* MD — the product gallery on touch is a real slider: every photograph sits on
   one horizontal track, so the next image is already under your finger while you
   drag. No source swap, no fade, no white flash. The thumbnail row stays in step.
   Desktop is untouched: there the main image and the thumbnails behave as before. */
(function () {
  var MOBILE = '(max-width: 900px)';

  function isTouch() {
    return window.matchMedia(MOBILE).matches &&
      ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }

  function thumbs(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
  }

  /* A thumbnail is served small; ask the CDN for a full-width copy. */
  function bigSrc(img) {
    var src = img.getAttribute('src') || '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$11600');
    return src;
  }

  function sources(gallery) {
    return thumbs(gallery).map(function (t) {
      var img = t.querySelector('img');
      return img ? { src: bigSrc(img), alt: img.getAttribute('alt') || '' } : null;
    }).filter(Boolean);
  }

  function markThumb(gallery, index) {
    var list = thumbs(gallery);
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute('aria-pressed', i === index ? 'true' : 'false');
    }
    var row = gallery.querySelector('.pdp__thumbs');
    var t = list[index];
    if (row && t && row.scrollWidth > row.clientWidth + 2) {
      row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
    }
  }

  function build(gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    if (!main || !main.parentElement) return;

    var list = sources(gallery);
    if (list.length < 2) return;

    var key = list.map(function (s) { return s.src; }).join('|');
    var track = gallery.querySelector('[data-md-track]');

    if (track && track.dataset.mdKey === key) return;
    if (track) track.remove();

    /* the track has to occupy exactly the frame the main image had */
    var cs = getComputedStyle(main);
    var ratio = cs.aspectRatio && cs.aspectRatio !== 'auto' ? cs.aspectRatio : null;
    var fit = cs.objectFit || 'cover';
    var pos = cs.objectPosition || 'center';
    var height = ratio ? '' : (main.getBoundingClientRect().height || 0);

    track = document.createElement('div');
    track.setAttribute('data-md-track', '');
    track.style.cssText = [
      'display:flex',
      'width:100%',
      'overflow-x:auto',
      'overflow-y:hidden',
      'scroll-snap-type:x mandatory',
      'scroll-behavior:auto',
      '-webkit-overflow-scrolling:touch',
      'overscroll-behavior-x:contain',
      'touch-action:pan-x pan-y',
      'scrollbar-width:none',
      'gap:0',
      'background:transparent'
    ].join(';');

    list.forEach(function (s, i) {
      var img = document.createElement('img');
      img.src = s.src;
      img.alt = s.alt;
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.draggable = false;
      img.style.cssText = [
        'flex:0 0 100%',
        'width:100%',
        'display:block',
        'scroll-snap-align:center',
        'scroll-snap-stop:always',
        'object-fit:' + fit,
        'object-position:' + pos,
        'user-select:none',
        '-webkit-user-drag:none',
        ratio ? 'aspect-ratio:' + ratio : (height ? 'height:' + height + 'px' : '')
      ].filter(Boolean).join(';');
      track.appendChild(img);
    });

    track.dataset.mdKey = key;
    main.parentElement.insertBefore(track, main);
    main.style.display = 'none';

    /* start on whichever image the page had selected */
    var startIndex = 0;
    var t = thumbs(gallery);
    for (var i = 0; i < t.length; i++) if (t[i].getAttribute('aria-pressed') === 'true') startIndex = i;
    if (startIndex) {
      requestAnimationFrame(function () { track.scrollLeft = track.clientWidth * startIndex; });
    }

    var settle;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var w = track.clientWidth || 1;
        markThumb(gallery, Math.max(0, Math.min(list.length - 1, Math.round(track.scrollLeft / w))));
      }, 90);
    }, { passive: true });

    /* a tap on a thumbnail glides the track instead of swapping a source */
    gallery.addEventListener('click', function (e) {
      var hit = e.target.closest('[data-thumb]');
      if (!hit || !gallery.contains(hit)) return;
      var idx = thumbs(gallery).indexOf(hit);
      if (idx < 0) return;
      track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
    }, true);
  }

  function teardown(gallery) {
    var track = gallery.querySelector('[data-md-track]');
    if (track) track.remove();
    var main = gallery.querySelector('[data-gallery-main]');
    if (main) main.style.display = '';
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gallery]'), function (g) {
      if (isTouch()) build(g); else teardown(g);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('load', boot);
  window.addEventListener('orientationchange', function () { setTimeout(boot, 250); });
  var rz;
  window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(boot, 250); });
  [300, 1000, 2200].forEach(function (ms) { setTimeout(boot, ms); });
})();
